import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e.response?.data?.detail;
        navigate("/admin", {
          replace: true,
          state: { authError: typeof detail === "string" ? detail : "Google sign-in failed." },
        });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink text-slate-300" data-testid="auth-callback-screen">
      <Logo className="h-12 w-12" />
      <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
      <p className="text-sm">Signing you in with Google…</p>
    </div>
  );
}
